module.exports = __webpack_public_path__ + "img/tonga.28efc883.svg";